import { useIssueReportGuideModal } from '@/hook';
import { INITIAL_Z_INDEX, LiveHelp, VIconButton, cn } from '@/package';
import { useIssueReportStore } from '@/store';

interface FloatingButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary';
}

const IssueReporter = ({ className }: FloatingButtonProps) => {
  const { openModal, Modal } = useIssueReportGuideModal();
  const { visible, position, variant } = useIssueReportStore();

  return (
    <>
      {visible && (
        <VIconButton
          aria-label="issue-reporter-button"
          Icon={LiveHelp}
          size="md"
          className={cn('fixed', className)}
          onClick={() => {
            openModal();
          }}
          style={{
            bottom: position.bottom,
            right: position.right,
            zIndex: INITIAL_Z_INDEX.MODAL,
          }}
          variant={variant}
        />
      )}
      <Modal />
    </>
  );
};

export default IssueReporter;
